import { Component, Input, OnInit } from '@angular/core';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';
import { TrackingKeywordSuggestion, KeywordConfig, KeywordResearch, KeywordResearchTypes, KeywordSuggestion, PageSuggestion } from '../../../../shared/models/keywords/keywords';
import { KeywordResearchService } from '../../../../services/keyword-research.service';

@Component({
  selector: 'app-components-shared-keyword-research-page',
  templateUrl: './page.component.html',
  styleUrls: ['../keyword-research/keyword-research.component.scss']
})
export class PageComponent implements OnInit {
  @Input() keywordResearchType: KeywordResearchTypes;
  @Input() customer: Boo.Objects.Customer;
  @Input() pendingKeywordResearch: KeywordResearch[];
  @Input() pageSuggestion: PageSuggestion;
  @Input() pageSuggestions: PageSuggestion[];
  @Input() trackingKeywordSuggestions: TrackingKeywordSuggestion[];
  @Input() keywordConfig: KeywordConfig;

  kwrSearchTerm = '';
  keywordResearchTypes_StrategyUpdate = KeywordResearchTypes.StrategyUpdate;
  websiteUrlStatuses_New = Boo.Objects.Enums.WebsiteUrlStatuses.New;

  constructor(
    private customerCampaignService: CustomerCampaignService,
    private keywordResearchService: KeywordResearchService) { }

  ngOnInit(): void {
    this.kwrSearchTerm = this.pageSuggestion.KeywordResearch
      .sort((a, b) => new Date(b.InsertedDate).getTime() - new Date(a.InsertedDate).getTime())[0]?.KeywordPhrase.toLowerCase() ?? '';
  }

  keywordSort = (a: KeywordSuggestion, b: KeywordSuggestion): number => this.keywordResearchService.keywordSort(a, b);

  get selectedKeywordSuggestions(): KeywordSuggestion[] {
    return this.pageSuggestion.KeywordSuggestions.filter(x => x.IsSelected);
  }

  get validationMessage(): string {
    if (this.pageSuggestion.Url && this.pageSuggestion.IsCampaignNational === this.customer.IsCampaignNational && !this.customerCampaignService.domainMatches(this.customer.Url, this.pageSuggestion.Url)) {
      return 'The page domain must match the customer domain.';
    }

    const requiredPages = this.keywordConfig?.MinimumPages || 1;
    const requiredKeywordsPerPage = (this.keywordConfig?.MinimumMainKeywords || 1) / requiredPages;

    if (this.pageSuggestion.KeywordSuggestions.filter(y => y.IsSelected && y.IsCampaignNational === this.customer.IsCampaignNational).length < requiredKeywordsPerPage) {
      return 'Page must have at least ' + requiredKeywordsPerPage + ' keywords.';
    }

    return '';
  }
}
